import { useLocation } from 'react-router-dom'
import AdminFinancial from 'services/AdminFinancial'
import Comission from 'services/Comission'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import Bill from 'components/Bill'

import { 
  Container, 
  InfoText, 
  BusinessContainer,
  Row,
  SubTitle,
  MoneyTextMask
} from '../../styles'

export default function Daily () {
  const location = useLocation ()
  const { formattedDay, dayBills, daySchedules } = location.state
  const dailyTotalEarnings = AdminFinancial.getAdminEarnings (dayBills)
  const dailyTotalExpenses = Comission.getTotalEarnings (daySchedules, { value: 'cutilei' })

  return (
    <Container>
      <AdminNavbar/>
      <BusinessContainer style={{
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
        width: 640
      }}>
        <SubTitle>Total do dia {formattedDay}</SubTitle>
        <Row style={{ marginTop: 10 }}>
          <InfoText>Faturamento diário bruto:</InfoText>
          <MoneyTextMask value={dailyTotalEarnings}/>
        </Row>
        <Row>
          <InfoText>Despesa diária com salões:</InfoText>
          <MoneyTextMask value={dailyTotalExpenses}/>
        </Row>
        <Row>
        <SubTitle>Receita deduzida de despesas:</SubTitle>
          <MoneyTextMask value={(dailyTotalEarnings - dailyTotalExpenses)}/>
        </Row>
      </BusinessContainer>
      {dayBills.map ((bill, index) => (
        <Bill data={bill} key={index}/>
      ))}
    </Container>
  )
}
